export enum NotificationStatuses {
  DeclinedPending = 'declined_pending',
  Viewed = 'viewed',
}

export type DistributionMethod = 'upload' | 'bulk' | 'bulk_match'

export type LogTypes = 'status_changed' | 'file_updated'
